export default __webpack_public_path__ + "static/media/LENS_CULINARIS_ATHILA_complete_4.7fe62338.jpg";